module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/floppy.png?0177c62463d9b6c17bd27e6abfdac54c";